module.exports = __webpack_public_path__ + "static/Relevant-Medium-991d4fff7611806125d7142fead22a20.woff";